import { render, staticRenderFns } from "./myDownload.vue?vue&type=template&id=584d82fe&scoped=true"
import script from "./myDownload.vue?vue&type=script&lang=js"
export * from "./myDownload.vue?vue&type=script&lang=js"
import style0 from "./myDownload.vue?vue&type=style&index=0&id=584d82fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d82fe",
  null
  
)

export default component.exports